import { render, staticRenderFns } from "./SelectorComercio.vue?vue&type=template&id=5ae85ef1&"
import script from "./SelectorComercio.vue?vue&type=script&lang=js&"
export * from "./SelectorComercio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports